import React from "react";

// components
import BaseApi from "../../utils/BaseApi";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import VisibilityIcon from '@mui/icons-material/Visibility';


class CommentReadAll extends React.Component {
    async readAll() {
        const url = `comment/readall/`;
        const data = {
            related_app_id: this.props.appId,
            related_app: this.props.appName,
            deleted_bool: 0,
            page_size: 10000,
        };
        const api = new BaseApi();
        await api.get(url, data);
        if (this.props.callBack){
            this.props.callBack();
        }
    }

    render() {
        return (
            <CommonCallBackButton
                callBack={this.readAll.bind(this)}
                icon={VisibilityIcon}
                label={'Прочитать все'}
                color={'primary'}
                variant={'soft'}
            />
        )
    }
}

export default CommentReadAll